// Translate
import { Trans, useTrans } from "@/i18n"

// UI
import { cn } from "@/lib/utils"
import { Heading } from "@/components/Typography"
import { Button } from "@/components/Button"
import { Disclaimer } from "@/components/Disclaimer"
import { Card } from "@/components/Card"
import { ChangePassword } from "@/components/forms/ChangePassword"

// Environment variables
import { AUTH_MFA_URL } from "@/lib/env"

/**
 * ProfileAccount
 * @returns
 */
export const ProfileAccount = () => {
	const t = useTrans("profile")

	return (
		<>
			<title>
				{t("common:common.web.title", {
					page: t("profile:profile.account_settings.title"),
				})}
			</title>

			<Disclaimer
				className="mb-3"
				title={t("profile:profile.security.title")}
				message={
					<p>
						{t("profile:profile.security.banner.copy")}
						<br />
						<br />
						<Trans
							i18nKey="profile:profile.security.banner.link"
							components={{
								u: <u />,
								strong: <strong />,
							}}
						/>
						<br /> <br />
						<a
							href={AUTH_MFA_URL}
							target="_blank"
							rel="noopener noreferrer"
							className={cn(
								"text-gray-500 hover:text-gray-700",
								"whitespace-nowrap text-sm font-medium",
							)}
						>
							<span>
								{t("profile:profile.security.banner.link.text")}
							</span>
						</a>
					</p>
				}
			/>

			<ChangePassword />

			<Card className="mt-8">
				<Heading as="h5" className="mb-3 text-gray-600 sm:truncate">
					{t("profile:profile.account_deletion.title")}
				</Heading>
				<p className="text-sm text-gray-500">
					{t("profile:profile.account_deletion.copy")}
					<br />
					<br />
					<strong>
						{t(
							"profile:profile.account_deletion.no-investments.header",
						)}
					</strong>
					<br />
					{t("profile:profile.account_deletion.no-investments.copy")}
					<br />
					<br />
					<strong>
						{t(
							"profile:profile.account_deletion.open-investments.header",
						)}
					</strong>
					<br />
					<Trans
						i18nKey="profile:profile.account_deletion.open-investments.copy"
						components={{
							a: (
								<a //eslint-disable-line jsx-a11y/anchor-has-content
									href="mailto:info@zonhub.com"
									className="font-medium text-secondary-300 hover:text-secondary-700"
								/>
							),
						}}
					/>
					<br />
					<br />
					{t("profile:profile.account_deletion.warning")} <br />
				</p>

				{/** Delete account button */}
				<a
					href={`mailto:info@zonhub.com?subject=${encodeURIComponent(
						t("profile:profile.account_deletion.button"),
					)}&body=${encodeURIComponent(
						t("profile:profile.account_deletion.email.body"),
					)}`}
				>
					<Button className="mt-4">
						{t("profile:profile.account_deletion.button")}
					</Button>
				</a>
			</Card>
		</>
	)
}
